const RTL_LANGUAGES = ['ar', 'arc', 'dv', 'fa', 'ha', 'he', 'khw', 'ks', 'ku', 'ps', 'ur', 'yi']

export function isRTL(locale) {
  return RTL_LANGUAGES.includes(locale)
}
